import Component from '~/components/component';
import animRounding from '../../helpers/anim-rounding';
import VideoTmp from '../video-tmp/video-tmp';
import States from '../../helpers/states'

export default class Slideshow extends Component {
    constructor(...args) {
        super(...args);

        this.params = {
            current: 0,
            next: 0,
            canClick: true
        }

        this.fullscreen = this.dom.component.getAttribute("data-fullscreen");

        this._retrieveDOM();

    }

    _retrieveDOM() {
        this.dom.containerImages = this.dom.component.querySelectorAll(".anim-container");
        this.dom.images = this.dom.component.querySelectorAll(".anim-container .inner");
        this.dom.prev = this.dom.component.querySelector('.prev');
        this.dom.next = this.dom.component.querySelector('.next');
        this.dom.text = this.dom.component.querySelectorAll(".container-text");
        this.dom.mask = this.dom.component.querySelectorAll(".anim-mask");
        this.dom.borderBottom = this.dom.component.querySelectorAll(".border-bottom");
        this.dom.sliderBottom = this.dom.component.querySelector('.slider-bottom');
        this.dom.sliderTop = this.dom.component.querySelector('.slider-top');

        this.params.total = this.dom.containerImages.length - 1;
    }

    bind() {
        super.bind();

        //Set height of container text for te first time
        this._setHeight(this.params.current);

        //Animation rounding
        this.animRounding = new animRounding({
            container: this.dom.containerImages,
            mask: this.dom.mask,
            inner: this.dom.images
        }, this.params.current, this._onComplete.bind(this));

        //Event click for slider
        if (this.dom.containerImages.length > 1){
            this.dom.prev.addEventListener("click", this._process.bind(this, "prev"));
            this.dom.next.addEventListener("click", this._process.bind(this, "next"));
        }

    }

    _process(direction){

        
        if ( this.params.canClick == false)
            return;

        for(var componentName in States.Components){
            var component = States.Components[componentName];

            // Bind Global VideoTmp Events
            if( component.length > 0 ) {
                for( let i = 0, j = component.length; i < j; i++) {
                    let componentTab = component[i];
                    if(componentTab instanceof VideoTmp){
                        componentTab.pause()
                    }
                }
            } else {
                if(component instanceof VideoTmp){
                    component.pause()                     
                }
            }
        }


        this.params.canClick = false;
        if ( direction == "next" && this.params.current < this.params.total){
            this.params.next++;
        }
        else if (direction == "next" && this.params.current == this.params.total) {
            this.params.next = 0;
        }
        else if (direction == "prev" && this.params.current > 0) {
            this.params.next--;
        }
        else if (direction == "prev" && this.params.current == 0) {
            this.params.next = this.params.total;
        }

        this.animText = new TimelineMax();

        this._animate();

    }

    _onComplete(indexCurrent) {
        this.params.current = indexCurrent;
        this.params.canClick = true;
    }


    _setHeight(index){

        if( this.dom.sliderBottom ) {
            let heightNextStep = this.dom.text[index].offsetHeight;
            TweenLite.to(this.dom.sliderBottom,0.6 , {height: heightNextStep, force3D:true, ease: Power3.easeInOut} );
        }


    }


    /*
    bind() {
    }
    unbind() {
    }

    */
}



// WEBPACK FOOTER //
// src/js/components/slideshow/slideshow.js